import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

interface IconButtonSelectProps {
  label: string
  onClick: () => void
  icon?: string
  className?: string
  textClassName?: string
}

const IconButtonSelect = ({ label, onClick, icon, className, textClassName }: IconButtonSelectProps) => {
  const isMobile = useIsMobile()
  if (isMobile) {
    return (
      <button
        className={cn(
          'flex h-[65px] w-full flex-row items-center justify-center gap-4 rounded-[20px] bg-accent p-5 text-primary transition-all duration-200 ease-in-out hover:bg-primary hover:text-white',
          className,
        )}
        onClick={onClick}
      >
        <div className="flex flex-row items-center justify-start gap-4">
          {icon && <img src={icon} alt={label} className="h-[40px] w-[70px] object-contain object-right" />}
          <span className={cn('text-center text-base font-semibold', textClassName)}>{label}</span>
        </div>
      </button>
    )
  }

  return (
    <button
      className={cn(
        'flex min-h-[100px] min-w-[220px] flex-col items-center justify-center gap-4 rounded-[12px] bg-accent p-7 text-primary transition-all duration-200 ease-in-out hover:bg-primary hover:text-white',
        className,
      )}
      onClick={onClick}
    >
      {icon && <img src={icon} alt={label} className="h-[60px] w-[100px] object-contain" />}
      <span className={cn('text-[20px] font-semibold leading-[140%] tracking-[-0.1px]', textClassName)}>{label}</span>
    </button>
  )
}
export default IconButtonSelect
